import { get } from 'lodash';
import dictionariesTypesEnum from '../../../../common/constants/dictionaries';

export const getDictionary = (state, type) => get(state, `dictionaries.${type}.dictionary`, []);
export const selectStoredDictionary = (state) => get(state, 'dictionaries.storedDictionaries');
export const selectPlazasDictionary = (state) => get(state.dictionaries, [dictionariesTypesEnum.plazas, 'dictionary']);
export const selectCustomersDictionary = (state) => get(state.dictionaries, [dictionariesTypesEnum.customers, 'dictionary']);
export const getDictionaryByType = (type) => (state) => get(state, `dictionaries.${type}.dictionary`, []);
export const selectProductTypeDictionary = (state) => get(state, `dictionaries.${dictionariesTypesEnum.productType}.dictionary`, []);